module.exports = __webpack_public_path__ + "static/media/header-mobile.52bb9556.jpg";